import script from "./_webhookDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./_webhookDetail.vue?vue&type=script&setup=true&lang=js"

import "./_webhookDetail.vue?vue&type=style&index=0&id=3f77b162&lang=scss"

const __exports__ = script;

export default __exports__